import React, { useState } from 'react';
import { FaFileExcel, FaFilePdf, FaSpinner } from 'react-icons/fa';
import { performanceChange } from './performanceModel';
import { exportPerformanceComparison, formatPerformanceValue } from './performanceReports';

export { formatPerformanceValue } from './performanceReports';

export default function PerformanceComparison({ metrics, currentLabel, previousLabel, context = '', onBeforeExport, exportDisabled = false }) {
  const [error, setError] = useState('');
  const [exporting, setExporting] = useState('');
  async function exportComparison(format) {
    if (exporting || exportDisabled || (onBeforeExport && !onBeforeExport(format))) return;
    setError('');
    setExporting(format);
    try {
      await exportPerformanceComparison(format, { metrics, currentLabel, previousLabel, context });
    } catch (exportError) {
      console.error('Erro ao exportar comparação de desempenho:', exportError);
      setError('Não foi possível exportar a comparação. Tente novamente.');
    } finally {
      setExporting('');
    }
  }
  return <section className="crop-performance-summary" aria-label="Comparação de desempenho">
    <div className="crop-performance-section-heading"><div><span>HISTÓRICO</span><h2>Comparação de desempenho</h2></div>
      <div className="performance-export-actions" role="group" aria-label="Exportar comparação">
        <button type="button" className="crop-performance-report-action" disabled={Boolean(exporting) || exportDisabled} onClick={() => exportComparison('xlsx')}>
          {exporting === 'xlsx' ? <FaSpinner className="crop-performance-spinner" aria-hidden="true" /> : <FaFileExcel aria-hidden="true" />} Exportar XLSX
        </button>
        <button type="button" className="crop-performance-report-action" disabled={Boolean(exporting) || exportDisabled} onClick={() => exportComparison('pdf')}>
          {exporting === 'pdf' ? <FaSpinner className="crop-performance-spinner" aria-hidden="true" /> : <FaFilePdf aria-hidden="true" />} Exportar PDF
        </button>
      </div></div>
    <div className="performance-table-wrap"><table className="performance-comparison">
      <caption>{currentLabel} em comparação com {previousLabel}</caption>
      <thead><tr><th scope="col">Indicador</th><th scope="col">Selecionado</th><th scope="col">Referência</th><th scope="col">Variação</th></tr></thead>
      <tbody>{metrics.map(metric => {
        const change = performanceChange(metric.current, metric.previous);
        return <tr key={metric.label}><th scope="row">{metric.label}</th>
          <td>{formatPerformanceValue(metric.current, metric.currency)}</td><td>{formatPerformanceValue(metric.previous, metric.currency)}</td>
          <td>{!change ? 'Dados insuficientes' : <>{change.difference > 0 ? '+' : ''}{formatPerformanceValue(change.difference, metric.currency)}
            <small>{change.percent == null ? 'Sem base percentual' : `${formatPerformanceValue(change.percent)}%`}</small></>}</td></tr>;
      })}</tbody>
    </table></div>
    <p className="performance-notice">Valores consultados nos registros atuais, sem fechamento imutável. Compare períodos de duração e cobertura semelhantes. Ausência de gastos não comprova custo zero; projeções não são vendas nem lucro.</p>
    {error && <p role="alert" className="crop-performance-error">{error}</p>}
  </section>;
}
